import { CheckCircle2, Clock, Zap, Target, TrendingUp, Sparkles, Shield, Star, Trophy, Compass, Infinity as InfinityIcon } from 'lucide-react';
import type { ModeId } from '../shared/modeTheme';
export interface ModeFeature {
  icon: React.ElementType;
  title: string;
  description: string;
  iconColorClass: string;
  iconBgClass: string;
}
export interface ModeIntroContent {
  djayMessage: string;
  features: ModeFeature[];
  primaryCta: string;
}
export const MODE_INTRO_CONTENT: Record<ModeId, ModeIntroContent> = {
  fluency: {
    djayMessage: 'Hoi! Bij Snel & Zeker oefen je dingen die je al kent. Het doel is om ze steeds sneller goed te krijgen!',
    primaryCta: 'Start!',
    features: [{
      icon: CheckCircle2,
      title: 'Bekende stof',
      description: 'Je krijgt vragen die je al eerder goed hebt beantwoord.',
      iconColorClass: 'text-emerald-600',
      iconBgClass: 'bg-emerald-100'
    }, {
      icon: Clock,
      title: 'Geen tijdslimiet',
      description: 'Doe het op jouw eigen tempo. Er is geen stress!',
      iconColorClass: 'text-blue-600',
      iconBgClass: 'bg-blue-100'
    }, {
      icon: Zap,
      title: 'Snelheidsmeting',
      description: 'Na afloop zie je hoe snel je gemiddeld was.',
      iconColorClass: 'text-amber-600',
      iconBgClass: 'bg-amber-100'
    }]
  },
  sprint: {
    djayMessage: 'Hoi! Bij Gerichte Training oefen je één onderwerp. Je krijgt vragen van makkelijk naar moeilijk — zo word je steeds beter!',
    primaryCta: 'Start!',
    features: [{
      icon: Target,
      title: 'Eén onderwerp',
      description: 'Je focust op één ding tegelijk. Dat werkt het beste!',
      iconColorClass: 'text-indigo-600',
      iconBgClass: 'bg-indigo-100'
    }, {
      icon: TrendingUp,
      title: 'Van makkelijk naar moeilijk',
      description: 'Je begint makkelijk en het wordt steeds uitdagender.',
      iconColorClass: 'text-emerald-600',
      iconBgClass: 'bg-emerald-100'
    }, {
      icon: Sparkles,
      title: '10 gerichte vragen',
      description: 'Na 10 vragen zie je hoeveel je bent gegroeid.',
      iconColorClass: 'text-amber-600',
      iconBgClass: 'bg-amber-100'
    }]
  },
  challenge: {
    djayMessage: 'Klaar voor een echte uitdaging? Kies een onderwerp waar je al goed in bent en bewijs dat je het écht snapt!',
    primaryCta: 'Kies onderwerp',
    features: [{
      icon: Shield,
      title: 'Minimaal 70% beheersing',
      description: 'Je kunt alleen onderwerpen kiezen die je al goed beheerst.',
      iconColorClass: 'text-violet-600',
      iconBgClass: 'bg-violet-100'
    }, {
      icon: Star,
      title: 'Verdien sterren',
      description: 'Hoe beter je scoort, hoe meer sterren je verdient.',
      iconColorClass: 'text-fuchsia-600',
      iconBgClass: 'bg-fuchsia-100'
    }, {
      icon: Trophy,
      title: 'Moeilijkere vragen',
      description: 'De vragen zijn een niveau hoger — laat zien wat je kunt!',
      iconColorClass: 'text-amber-600',
      iconBgClass: 'bg-amber-100'
    }]
  },
  free: {
    djayMessage: 'Bij Vrij Oefenen kies je zelf wat je wilt doen. Geen regels, geen tijdslimiet — jij bepaalt!',
    primaryCta: 'Start!',
    features: [{
      icon: Compass,
      title: 'Jouw keuze',
      description: 'Kies elk onderwerp dat je wilt oefenen.',
      iconColorClass: 'text-teal-600',
      iconBgClass: 'bg-teal-100'
    }, {
      icon: InfinityIcon,
      title: 'Geen limiet',
      description: 'Oefen zo lang of kort als je wilt.',
      iconColorClass: 'text-emerald-600',
      iconBgClass: 'bg-emerald-100'
    }, {
      icon: Sparkles,
      title: 'Alle vakken',
      description: 'Kies uit alle onderwerpen die passen bij jouw niveau.',
      iconColorClass: 'text-amber-600',
      iconBgClass: 'bg-amber-100'
    }]
  }
};